import React, { Component } from 'react';
import { connect } from 'react-redux';

import { receiveError } from '../../store/actions/notificationAction';
import ResponseError from '../../models/ResponseError';

import WhsMain from './WhsMain'
import { requestOrderUnlocked } from '../../store/actions/orderLockedAction';

interface WhsMainContainerProps {
  receiveError: Function;
  orderLockedNumber: string;
  requestOrderUnlocked: Function;
};
  
interface WhsMainContainerState {
  value: string;
  numbersImport: number;
  numbersExport: number;
  numbersRfs: number;
  numbersGo: number;
};

class WhsMainContainer extends Component<WhsMainContainerProps, WhsMainContainerState> {

  state = {
    value: 'po',
    numbersImport: 0,
    numbersExport: 0,
    numbersRfs: 0,
    numbersGo: 0
  }

  componentDidMount() {
    if (this.props.orderLockedNumber) {
      this.props.requestOrderUnlocked(this.props.orderLockedNumber);
    }
  }

  handleChange = (event: any, value:string): void => {
    this.setState({value });
  };

  allyProps = (index: number): {id: number} => {
      return { id: index }
  }

  setCounts = (type: string, count: number): void => {
    if (type === 'po') {
      this.setState({numbersImport: count});
    }

    if (type === 'do') {
      this.setState({numbersExport: count});
    }

    if (type === 'rfs') {
      this.setState({numbersRfs: count});
    }

    if (type === 'go') {
      this.setState({numbersGo: count});
    }
  }

  render() {

    return (
      <WhsMain
        value={ this.state.value }
        handleChange={ this.handleChange }
        numbersImport={ this.state.numbersImport }
        numbersExport={ this.state.numbersExport }
        numbersRfs={ this.state.numbersRfs }
        numbersGo={ this.state.numbersGo }
        setCounts ={ this.setCounts }
      />
    )
  }
}

const mapStateToProps = (state: any) => {
  return {
    orderLockedNumber: state.orderLockedNumber
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    requestOrderUnlocked: (orderNumber: string) => dispatch(requestOrderUnlocked(orderNumber))
  };
};
  
export default connect(mapStateToProps, mapDispatchToProps)(WhsMainContainer);